import { DEFAULT_PRUEBAS_OPTIONS } from "./defaultPruebasOptions";
import { DEFAULT_SCENARIO2_OPTIONS } from "./defaultScenario2Options";
import { DEFAULT_SCENARIO3_OPTIONS } from "./defaultScenario3Options";
import { DEFAULT_SCENARIO5_OPTIONS } from "./defaultScenario5Options";
import { DEFAULT_SCENARIO52_OPTIONS } from "./defaultScenario52Options";
import { DEFAULT_SCENARIO52_Q2_OPTIONS } from "./defaultScenario52Question2Options";
import { DEFAULT_SCENARIO6_OPTIONS } from "./defaultScenario6Options";
import { DEFAULT_SCENARIO7_OPTIONS, DEFAULT_SCENARIO72_OPTIONS, DEFAULT_SCENARIO73_OPTIONS } from "./defaultScenario7Options";
import { getDefaultSupertestOptions } from "./defaultSupertestOptions";

function isScenario2Name(quizData) {
	if (!quizData || !quizData.scenario) return false;
	const name = (quizData.scenario.fullName || "").toLowerCase();
	return name.includes("2") || name.includes("escenario 2");
}

function isScenario3Name(quizData) {
	if (!quizData || !quizData.scenario) return false;
	const name = (quizData.scenario.fullName || "").toLowerCase();
	return name.includes("3") || name.includes("escenario 3") || name.includes("diagnóstico por imagen");
}

function isScenario5Name(quizData) {
	if (!quizData || !quizData.scenario) return false;
	const name = (quizData.scenario.fullName || "").toLowerCase();
	return name.includes("5") || name.includes("escenario 5");
}

function isScenario6Name(quizData) {
	if (!quizData || !quizData.scenario) return false;
	const name = (quizData.scenario.fullName || "").toLowerCase();
	return name.includes("6") || name.includes("escenario 6") || name.includes("ajuste de dosis");
}

function isScenario7Name(quizData) {
	if (!quizData || !quizData.scenario) return false;
	const scenarioName = (quizData.scenario.fullName || "").toLowerCase();
	const quizName = (quizData.fullName || "").toLowerCase();
	return scenarioName.includes("7") || scenarioName.includes("escenario 7") || scenarioName.includes("tiempo de tratamiento") || quizName.includes("duración") || quizName.includes("glosen");
}

const QUIZ_ID_SCENARIO7_2 = "667ebce7d3dd862f3c03ec03";
const QUIZ_ID_SCENARIO7_3 = "667ebce9d3dd862f3c03ec05";

/** Quiz scenario7-3: una afirmación V/F (KDIGO), mismo esquema que 7-2. Se distingue por ID o nombre KDIGO/7-3. */
function isScenario73Name(quizData) {
	if (!quizData || !isScenario7Name(quizData)) return false;
	const id = quizData._id || quizData.id;
	if (id && String(id) === QUIZ_ID_SCENARIO7_3) return true;
	const quizName = (quizData.fullName || "").toLowerCase();
	return quizName.includes("kdigo") || quizName.includes("7-3");
}

/** Quiz scenario7-2: una afirmación V/F (1 opción), enunciado + correct + cita. Se distingue por ID, 1 opción o nombre EULAR/sociedades. */
function isScenario72Name(quizData) {
	if (!quizData || !isScenario7Name(quizData)) return false;
	if (isScenario73Name(quizData)) return false;
	const id = quizData._id || quizData.id;
	if (id && String(id) === QUIZ_ID_SCENARIO7_2) return true;
	const opts = quizData.options;
	const quizName = (quizData.fullName || "").toLowerCase();
	if (opts && opts.length === 1) return true;
	return quizName.includes("eular") || quizName.includes("sociedades") || quizName.includes("7-2") || quizName.includes("otras sociedades");
}

function isScenario52Question2Name(quizData) {
	if (!quizData) return false;
	const quizName = (quizData.fullName || "").toLowerCase();
	return quizName.includes("infiltrada") || quizName.includes("5.2-2") || quizName.includes("5.2.2");
}

function isScenario52Name(quizData) {
	if (!quizData) return false;
	const scenarioName = (quizData.scenario?.fullName || "").toLowerCase();
	const quizName = (quizData.fullName || "").toLowerCase();
	// Por nombre del escenario
	if (scenarioName.includes("5.2") || scenarioName.includes("escenario 5.2") || scenarioName.includes("parte 2") || scenarioName.includes("aurora"))
		return true;
	// Por nombre del quiz (ej. "Afirmaciones Aurora V/F")
	if (quizName.includes("aurora") && (quizName.includes("v/f") || quizName.includes("afirmaciones")))
		return true;
	return false;
}

function isScenario8Name(quizData) {
	if (!quizData || !quizData.scenario) return false;
	const scenarioName = (quizData.scenario.fullName || "").toLowerCase();
	const quizName = (quizData.fullName || "").toLowerCase();
	return scenarioName.includes("supertest") || quizName.includes("supertest 1") || quizName.includes("supertest 2") || quizName.includes("supertest 3");
}

/**
 * Devuelve las opciones por defecto según el quiz (escenario 1 = Solicitar pruebas, escenario 2 = Diagnóstico, etc.).
 * @param {{ scenario?: { fullName?: string } }} quizData - quiz devuelto por getQuizById (scenario puede estar poblado)
 */
export function getDefaultQuizOptions(quizData) {
	if (!quizData || !quizData.scenario) return DEFAULT_PRUEBAS_OPTIONS;
	if (isScenario8Name(quizData)) return getDefaultSupertestOptions(quizData);
	if (isScenario2Name(quizData)) return DEFAULT_SCENARIO2_OPTIONS;
	if (isScenario3Name(quizData)) return DEFAULT_SCENARIO3_OPTIONS;
	if (isScenario52Question2Name(quizData)) return DEFAULT_SCENARIO52_Q2_OPTIONS;
	if (isScenario52Name(quizData)) return DEFAULT_SCENARIO52_OPTIONS;
	if (isScenario5Name(quizData)) return DEFAULT_SCENARIO5_OPTIONS;
	if (isScenario6Name(quizData)) return DEFAULT_SCENARIO6_OPTIONS;
	if (isScenario72Name(quizData)) return DEFAULT_SCENARIO72_OPTIONS;
	if (isScenario73Name(quizData)) return DEFAULT_SCENARIO73_OPTIONS;
	if (isScenario7Name(quizData)) return DEFAULT_SCENARIO7_OPTIONS;
	return DEFAULT_PRUEBAS_OPTIONS;
}

/** True si el quiz es del escenario 2 (Diagnóstico): el nombre de las opciones no se edita y se muestra "Diagnóstico 1", "Diagnóstico 2", etc. por orden. */
export function isScenario2Quiz(quizData) {
	return isScenario2Name(quizData);
}

/** True si el quiz es del escenario 3 (Diagnóstico por imagen): se editan etiqueta e imagen por opción. */
export function isScenario3Quiz(quizData) {
	return isScenario3Name(quizData);
}

/** True si el quiz es del escenario 5: en la web el orden es aleatorio y a)/b)/c)/d) por posición; en backoffice se muestra la justificación. */
export function isScenario5Quiz(quizData) {
	return isScenario5Name(quizData);
}

/** True si el quiz es del escenario 5.2 (Aurora V/F): se edita el texto de cada afirmación y la justificación; no se sustituye por a)/b)/c)/d). */
export function isScenario52Quiz(quizData) {
	return isScenario52Name(quizData);
}

/** True si el quiz es del escenario 5.2-2 (Afirmación infiltrada): 5 opciones, una es la infiltrada; misma UI que 5.2 en backoffice. */
export function isScenario52Question2Quiz(quizData) {
	return isScenario52Question2Name(quizData);
}

/** True si el quiz es del escenario 6 (Ajuste de dosis): 5 opciones, correct = id del filtro (1|2|3) para el que es correcta. */
export function isScenario6Quiz(quizData) {
	return isScenario6Name(quizData);
}

/** True si el quiz es del escenario 7-2 (EULAR, una afirmación V/F): 1 opción con text, correct, explanation, confirmExplanation. */
export function isScenario72Quiz(quizData) {
	return isScenario72Name(quizData);
}

/** True si el quiz es del escenario 7-3 (KDIGO, una afirmación V/F): mismo esquema que 7-2. */
export function isScenario73Quiz(quizData) {
	return isScenario73Name(quizData);
}

/** True si el quiz es del escenario 7 (Tiempo de tratamiento): 3 apartados (filterLabels), 9 opciones (3 por apartado), una correcta por apartado. */
export function isScenario7Quiz(quizData) {
	return isScenario7Name(quizData) && !isScenario72Name(quizData) && !isScenario73Name(quizData);
}

/** True si el quiz es del Supertest (escenario 8): varias opciones de tipo test, una correcta; se edita texto de opción y cuál es correcta. */
export function isSupertestQuiz(quizData) {
	return isScenario8Name(quizData);
}

/** Texto plano a partir de HTML; opcionalmente truncado para vista en tabla. */
export function explanationPreview(html, maxLen = 80) {
	if (!html || typeof html !== "string") return "—";
	const div = document.createElement("div");
	div.innerHTML = html;
	const text = (div.textContent || div.innerText || "").trim().replace(/\s+/g, " ");
	return text.length > maxLen ? text.slice(0, maxLen) + "…" : text || "—";
}
